import { Box, Button, Grid, Typography } from '@mui/material'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApplicationContext } from '../App'
import { Identity, Request } from '../interfaces/applicationContext'
import { approveRequest } from '../services/claimsService'

const getRequestLabel = (request: Request, identities: Identity[]) => {
    const requester = identities.find((identity) => identity.did === request.sender)?.displayName
    if (request.requestedType === '837') {
        return `${requester} has requested access to 837 with claim number ${request.claimNumberOrPatientControlNumber}`
    } else if (request.requestedType === '835') {
        return `${requester} has requested access to 835 with patient control number ${request.claimNumberOrPatientControlNumber}`
    } else if (request.requestedType === 'message') {
        return `${requester} has requested access to message in claim ${request.claimNumberOrPatientControlNumber}`
    }
}

export const Requests: React.FC = () => {
    const { identities, requests, setLastUpdate } = useContext(ApplicationContext)
    const navigate = useNavigate()

    const handleApprove = (id: string) => {
        approveRequest(id).then((response) => {
            if (response.data) {
                setLastUpdate(new Date().getTime())
            } else {
                // TODO
            }
        })
    }

    return (
        <Grid container direction="column" style={{ padding: '40px' }}>
            <Grid item>
                <Typography style={{ marginBottom: '30px' }} variant="h3">
                    Requests
                </Typography>
            </Grid>
            <Grid item>
                {requests.map((request) => (
                    <Box
                        key={request.id}
                        style={{
                            backgroundColor: '#F2F6F9',
                            padding: '15px',
                            borderRadius: '5px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography>{getRequestLabel(request, identities || [])}</Typography>
                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                variant="contained"
                                disableElevation={true}
                                style={{
                                    minWidth: '120px',
                                    borderRadius: '18px',
                                    marginRight: '10px',
                                }}
                                onClick={() =>
                                    navigate(
                                        `/claims/${request.claimNumberOrPatientControlNumber}/summary`,
                                    )
                                }
                            >
                                View Claim
                            </Button>
                            <Button
                                variant="contained"
                                disableElevation={true}
                                style={{
                                    minWidth: '120px',
                                    borderRadius: '18px',
                                    marginRight: '10px',
                                }}
                                onClick={() => handleApprove(request.id)}
                            >
                                Approve
                            </Button>
                        </Box>
                    </Box>
                ))}
                {requests.length === 0 && (
                    <Typography
                        variant="h6"
                        style={{ marginTop: '200px', textAlign: 'center', color: 'grey' }}
                    >
                        There are no pending requests
                    </Typography>
                )}
            </Grid>
        </Grid>
    )
}
